import get from 'lodash.get';
import hasWindow from './hasWindow';

const DOMAINS = ['godaddy\\.com', 'secureserver\\.net'];
const DOMAIN_MATCH = 0;

const RE = new RegExp(`\\b(dev-|test-)?(${DOMAINS.join('|')})$`);

const getCookieHost = () => {
  const matches = get(hasWindow() ? window : {}, 'location.host', '').match(RE);

  return matches?.[DOMAIN_MATCH] || null;
};

export default getCookieHost;
